// The one way to hand the user a generated file (exports, templates). On the
// website it is the classic hidden-anchor download. In the native shell both
// webviews silently ignore the download attribute, so there the blob is
// written to the app's cache and offered through the system share sheet
// (Save to Files, AirDrop, Drive, ...). Plugins load dynamically so none of
// this touches the web bundle.
import { Capacitor } from '@capacitor/core';

function blobToBase64(blob) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = () => reject(reader.error);
    // result is a data: URL — the base64 payload starts after the comma.
    reader.onload = () => resolve(String(reader.result).split(',')[1]);
    reader.readAsDataURL(blob);
  });
}

export async function saveBlobFile(blob, filename) {
  if (Capacitor.isNativePlatform()) {
    const [{ Filesystem, Directory }, { Share }] = await Promise.all([
      import('@capacitor/filesystem'),
      import('@capacitor/share'),
    ]);
    const { uri } = await Filesystem.writeFile({
      path: filename,
      data: await blobToBase64(blob),
      directory: Directory.Cache,
    });
    // Dismissing the sheet rejects — that's a user choice, not a failure.
    await Share.share({ files: [uri] }).catch(() => {});
    return;
  }

  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

export const XLSX_MIME = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
